import React from 'react';

import SectionTitle from '../../../components/academy/packages/SectionTitle';
import PriceCard from '../../../components/academy/packages/PriceCard';
import JoinCapsterButton from '../../../components/academy/packages/JoinCapsterButton';
import JoinHairstylishButton from '../../../components/academy/packages/JoinHairstylishButton';

import ManPackageData from '../Packages/Data/ManPackageData';
import HairstylishPackageData from '../Packages/Data/HairstylishPackageData';

function SecondSection() {
  return (
    <div className="py-20">
      <div className="mb-8 px-20">
        <SectionTitle>PAKET TRAINING CAPSTER</SectionTitle>
        <div className={`flex flex-wrap justify-center  gap-6 mt-16 mb-16`}>
          {ManPackageData.map((pkg, index) => (
            <PriceCard key={index} {...pkg} />
          ))}
        </div>
        <JoinCapsterButton />
      </div>

      <div className='px-20'> 
        <SectionTitle >PAKET TRAINING HAIRSTYLIST</SectionTitle>
        <div className="flex flex-wrap justify-center gap-6 mt-16 mb-16">
          {HairstylishPackageData.map((pkg, index) => (
            <PriceCard key={index} {...pkg} />
          ))}
        </div>
        <JoinHairstylishButton />
      </div>
    </div>
  )
  
}

export default SecondSection